import pathfinder from '@fiverr-private/pathfinder';

export const helpers = {
    openPageTab: (url: string) => window.open(url, '_blank'),
    redirectTo: (url: string) => (window.location.href = url),
};

export const openFreelancerProfile = (sellerName: string) => {
    helpers.openPageTab(pathfinder('freelancer_page', { username: sellerName }));
};

export const formatDate = (date: string | Date | undefined) => {
    if (!date) {
        return undefined;
    }
    const options: Intl.DateTimeFormatOptions = {
        year: '2-digit',
        month: 'short',
        day: 'numeric',
    };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate;
};

export const calculateEstimationDate = (timestamp: number | undefined, daysToAdd: number) => {
    if (!timestamp) {
        return undefined;
    }
    const resultDate = new Date(timestamp);
    resultDate.setDate(resultDate.getDate() + daysToAdd);
    return resultDate.toISOString();
};

export const formatDateShort = (date: string | undefined) => {
    if (!date) {
        return undefined;
    }
    const options: Intl.DateTimeFormatOptions = {
        month: 'long',
        day: 'numeric',
    };
    const formattedDate = new Date(date).toLocaleDateString('en-US', options);
    return formattedDate;
};

export const redirectToPaymentsPage = (paymentSessionID: string) => {
    helpers.redirectTo(pathfinder('payments_page', undefined, { query: { paymentSessionID } }));
};

export const addQueryParam = (url: string, paramKey: string, paramValue: string): string => {
    const parsedUrl = new URL(url);
    const searchParams = parsedUrl.searchParams;

    searchParams.set(paramKey, paramValue);
    return `${parsedUrl.origin}${parsedUrl.pathname}?${searchParams.toString()}`;
};

const INVITE_BRIEF_REGEX = /\/briefs\/manage\b.*\/invite\b/;
const OFFERS_BRIEF_REGEX = /\/briefs\/manage\b.*\/offers\b/;
const ORDERS_REGEX = /^\/orders\b/;
const LISTINGS_REGEX = /^\/categories\b/;
const INBOX_REGEX = /^\/inbox\b/;
const FREELANCERS_PAGE_REGEX = /^\/freelancers\b/;
const AGENCIES_PAGE_REGEX = /^\/agencies\b/;
export const getPageSource = () => {
    const pathname = window?.location.pathname;
    if (pathname === '/') {
        return 'landing_home_page';
    } else if (pathname === '/workspace/freelance_network/') {
        return 'freelance_network_page_all_hires';
    } else if (pathname === '/workspace/freelance_network/recently_viewed') {
        return 'freelance_network_page_recently_viewed';
    } else if (FREELANCERS_PAGE_REGEX.test(pathname)) {
        return 'freelancers_page';
    } else if (INBOX_REGEX.test(pathname)) {
        return 'inbox_page';
    } else if (INVITE_BRIEF_REGEX.test(pathname)) {
        return 'brief_manage_invite';
    } else if (OFFERS_BRIEF_REGEX.test(pathname)) {
        return 'brief_manage_offers';
    } else if (ORDERS_REGEX.test(pathname)) {
        return 'order_page';
    } else if (LISTINGS_REGEX.test(pathname)) {
        return 'categories_listings_page';
    } else if (AGENCIES_PAGE_REGEX.test(pathname)) {
        return 'agencies_page';
    }
    return 'unknown';
};
